import * as tslib_1 from "tslib";
var CODE = 'NewPasswordRequired';
var NewPasswordRequiredError = /** @class */ (function (_super) {
    tslib_1.__extends(NewPasswordRequiredError, _super);
    function NewPasswordRequiredError() {
        var _this = _super.call(this, CODE) || this;
        _this['error'] = { code: CODE };
        return _this;
    }
    return NewPasswordRequiredError;
}(Error));
export { NewPasswordRequiredError };
